export default __webpack_public_path__ + "static/media/affiliate-2.0f735023.jpg";